module.exports = __webpack_public_path__ + "static/img/2bg_6.ddaa388.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_6.png
// module id = 674
// module chunks = 1